import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

export const OrganizationMaster = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Organization/GetOrgLocationMappingMaster`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const OrganizationNamesList = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Organization/GetOrganizationNamesList`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const AddOrgLocationMapping = async (payload) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Organization/AddOrgLocationMapping`, payload, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const ActivateDeActivateOrgLocationMapping = async(Id, IsActive) => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `Organization/ActivateDeActivateOrgLocationMappingList?Id=${Id}&IsActive=${IsActive}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const ActivateDeActivateProcessingLocation = async(Id, Is_Processing_Location) => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `Organization/ActivateDeActivateProcessingLocation?Id=${Id}&Is_Processing_Location=${Is_Processing_Location}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}